import React, { useEffect, useState } from "react";
import { MsalProvider, useMsal } from "@azure/msal-react";
import LoadingScreen from "react-loading-screen";
import { clientId, redirectUri, authority, scopes } from "./AuthConfig";

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { connect } from "react-redux";
import { toast } from "react-toastify";

const AuthButton = (props) => {
  const msalConfig = {
    auth: {
      clientId: clientId,
      redirectUri: redirectUri,
      authority: authority,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);

  // "bri.tst01@mmhe.com.my";

  // "nursabrina@mmhe.com.my";

  // maizatul.naziha@mmhe.com.my

  // natasha.amira@mmhe.com.my

  const MicrosoftLoginButton = () => {
    const { instance } = useMsal();
    const [isLoading, setIsLoading] = useState(false);
    localStorage.setItem("loginCount", "false");

    const isLogin = async (token, name) => {
      try {
        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            `/api/Login/Login?username=${
              process.env.REACT_APP_ENV == "http://localhost:3000" ? name : name
            }`,
          {
            method: "POST",
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              setIsLoading(false);
              props.dispatch({ type: "Referenceno", value: "" });
              props.dispatch({ type: "UserId", value: "" });
              props.dispatch({ type: "profile", value: "" });
              props.dispatch({ type: "headerTitle", value: "" });
              props.dispatch({ type: "Token", value: "" });
              props.dispatch({ type: "userType", value: "" });
              props.dispatch({ type: "userName", value: "" });
              props.dispatch({ type: "designationName", value: "" });
              toast.error(" Incorrect username or password.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
             
            }
          })
          .then((profile) => {
            if (profile) {
              props.dispatch({
                type: "Token",
                value: token,
              });
              props.dispatch({
                type: "userType",
                value: profile?.resultObject?.userType,
              });
              props.dispatch({
                type: "userName",
                value: profile?.resultObject?.name,
              });
              props.dispatch({
                type: "UserId",
                value: profile?.resultObject?.employeeid,
              });
              props.dispatch({
                type: "designationName",
                value: profile?.resultObject?.designationname,
              });

              if (profile?.resultObject?.employeeid) {
                const loginCount = localStorage.getItem("loginCount");
                if (loginCount === "false") {
                  toast.success("Login successfully.", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                  });
                  localStorage.setItem("loginCount", "true");
                }
              } else {
                setIsLoading(false);
                localStorage.clear();
                sessionStorage.clear();
                toast.error(" Incorrect username or password.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              }
            }
          })
          .catch((error) => {
            setIsLoading(false);
            toast.error("Something went wrong! please try again", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            console.log(error);
            props.dispatch({ type: "Referenceno", value: "" });
            props.dispatch({ type: "UserId", value: "" });
            props.dispatch({ type: "profile", value: "" });
            props.dispatch({ type: "headerTitle", value: "" });
            props.dispatch({ type: "Token", value: "" });
            props.dispatch({ type: "userType", value: "" });
            props.dispatch({ type: "userName", value: "" });
            props.dispatch({ type: "designationName", value: "" });
          });
      } catch (e) {
        setIsLoading(false);
        toast.error("Something went wrong! please try again", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        console.log(e);
        props.dispatch({ type: "Referenceno", value: "" });
        props.dispatch({ type: "UserId", value: "" });
        props.dispatch({ type: "profile", value: "" });
        props.dispatch({ type: "headerTitle", value: "" });
        props.dispatch({ type: "Token", value: "" });
        props.dispatch({ type: "userType", value: "" });
        props.dispatch({ type: "userName", value: "" });
        props.dispatch({ type: "designationName", value: "" });
      }
    };

    const handleLogin = async () => {
      try {
        const accounts = msalInstance.getAllAccounts();

        if (accounts[0]) {
          try {
            const silentResponse = await msalInstance.acquireTokenSilent({
              scopes: scopes,
              account: accounts[0],
            });

            if (silentResponse) {
              setIsLoading(true);
              isLogin(
                silentResponse.accessToken,
                silentResponse.account.username
              );

              return null;
            }
          } catch (silentError) {
            if (silentError.name === "InteractionRequiredAuthError") {
              await instance.loginRedirect({
                scopes: scopes,
                prompt: "login",
              });
              return null;
            } else {
              setIsLoading(false);
              console.error("Silent authentication error:", silentError);
              toast.error("Silent authentication error", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
            }
          }
        }

        const loginResponse = await instance.loginRedirect({
          scopes: scopes,
          prompt: "login",
        });
      } catch (error) {
        console.error("Error logging in:", error);
      }
    };

    //   try {
    //     const accounts = msalInstance.getAllAccounts();
    //     if (accounts[0]) {
    //       const silentResponse = await msalInstance.acquireTokenSilent({
    //         scopes: scopes,
    //         account: accounts[0],
    //       });
    //       if (silentResponse) {
    //         isLogin(
    //           silentResponse.accessToken,
    //           silentResponse.account.username
    //         );
    //         return null;
    //       } else {
    //         toast.error("Something went wrong:", {
    //           position: toast.POSITION.TOP_CENTER,
    //           autoClose: 2000,
    //         });
    //       }
    //     }
    //     const loginResponse = await instance.loginRedirect({
    //       scopes: scopes,
    //     });
    //   } catch (error) {
    //     console.error("Error logging in:", error);
    //     toast.error("Error logging in:", {
    //       position: toast.POSITION.TOP_CENTER,
    //       autoClose: 2000,
    //     });
    //   }
    // };

    msalInstance.addEventCallback((response) => {
      if (response.eventType === EventType.LOGIN_SUCCESS) {
        setIsLoading(true);
        isLogin(
          response.payload.accessToken,
          response.payload.account.username
        );
      } else if (response.eventType === EventType.LOGIN_FAILURE) {
        toast.error("Please login with correct Microsoft credentails", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    });

    useEffect(() => {
      let isMounted = true;

      const intialLogin = async () => {
        try {
          if (!isLoading && isMounted) {
            await handleLogin();
          }
        } catch (error) {
          console.error("Error during login:", error);
        }
      };

      setTimeout(intialLogin, 1000);

      return () => {
        isMounted = false;
      };
    }, [isLoading, handleLogin]);

    return (
      <LoadingScreen
        loading={isLoading}
        bgColor="#f1f1f1"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={process.env.REACT_APP_ENV + "/assets/images/logo/GGP-logo.png"}
      >
        {/* <div className="newHome d-flex justify-content-center align-items-center">
          <div className="card d-flex justify-content-center align-items-center">
            <img src="/assets/images/logo/GGP-logo.png"></img>
            <section className="d-flex flex-column justify-content-center align-items-center w-100">
              <h6>Welcome to eDoc</h6>
              <button className="btn" onClick={handleLogin}>
                Login
              </button>
            </section>
          </div>
        </div> */}
      </LoadingScreen>
    );
  };

  return (
    <MsalProvider instance={msalInstance} scopes={["user.read"]}>
      <MicrosoftLoginButton />
    </MsalProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
    designationName: state.designationName,
  };
};

export default connect(mapStateToProps)(AuthButton);
